// extracted by mini-css-extract-plugin
export default {"gridSix":"ServiceChannelsBody-module__[local]___-vGeq","grid":"ServiceChannelsBody-module__[local]___YMQV0","wrapper":"ServiceChannelsBody-module__[local]___O4t4X"};